import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';






import {NavbarModule} from 'app/layout/components/navbar/navbar.module';

import {ToolbarModule} from 'app/layout/components/toolbar/toolbar.module';

import {VerticalLayout3Component} from './layout-3.component';
import {AjudaPanelModule} from '../../components/ajuda-panel/ajuda-panel.module';
import {ChatPanelModule} from "../../components/chat-panel/chat-panel.module";


@NgModule({
    imports: [
    RouterModule,
    NavbarModule,
    AjudaPanelModule,
    ChatPanelModule,
    ToolbarModule,
    VerticalLayout3Component
],
    exports: [
        VerticalLayout3Component
    ]
})
export class VerticalLayout3Module {
}
